"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vue_router_1 = __importDefault(require("vue-router"));
const routes_1 = __importDefault(require("./routes"));
const front_guard_1 = __importDefault(require("./front-guard"));
const post_guard_1 = __importDefault(require("./post-guard"));
vue_1.default.use(vue_router_1.default);
const router = new vue_router_1.default({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes_1.default
});
// 解决重复点击相同路由报错
const VueRouterPush = vue_router_1.default.prototype.push;
vue_router_1.default.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch((err) => err);
};
router.beforeEach(front_guard_1.default);
router.afterEach(post_guard_1.default);
exports.default = router;
